// extracted by mini-css-extract-plugin
export var askAiIcon = "_os-k";
export var category = "_os-a";
export var categoryHeader = "_os-f";
export var container = "_os-0";
export var group = "_os-b";
export var groupItems = "_os-g";
export var groupSeparator = "_os-l";
export var highlight = "_os-8";
export var loading = "_os-1";
export var noResults = "_os-3";
export var placeholder = "_os-2";
export var resultContent = "_os-5";
export var resultIcon = "_os-d";
export var resultItem = "_os-h";
export var resultMeta = "_os-9";
export var resultSubtitle = "_os-7";
export var resultSuffix = "_os-j";
export var resultTitle = "_os-6";
export var resultsList = "_os-4";
export var searchGroup = "_os-e";
export var selected = "_os-i";
export var subgroup = "_os-c";